import type { PerformanceEntry } from "./index.d"

const NAMESPACE = "liqa"

export type Measurement = {
  instantDuration: number
  averagedDuration: number
}

const averages = new Map<string, Measurement["averagedDuration"]>()
const invocations = new Map<string, number>()

export const mark: PerformanceEntry["mark"] = (name: string) => {
  let id = invocations.get(name) ?? -1
  invocations.set(name, (id += 1))

  const invocationName = `${name}_${id}`
  const invocationStartName = start(invocationName)
  const invocationEndName = end(invocationName)

  performance.mark(invocationStartName)

  const measure = () => {
    performance.mark(invocationEndName)

    let measure = performance.measure(invocationName, invocationStartName, invocationEndName)
    if (!measure) measure = performance.getEntriesByName(invocationName)[0] as PerformanceMeasure

    performance.clearMarks(invocationStartName),
      performance.clearMarks(invocationEndName),
      performance.clearMeasures(invocationName)

    const { duration: instantDuration } = measure
    const averagedDuration = averages.get(name) || 0
    averages.set(name, mix(averagedDuration, instantDuration, 0.05))

    return { instantDuration, averagedDuration }
  }

  const child = () => ({ mark })

  return { measure, child }
}

const mix = (x: number, y: number, a: number) => x * (1 - a) + y * a
const start = (name: string) => `${NAMESPACE}::${name}:start`
const end = (name: string) => `${NAMESPACE}::${name}:end`
